/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import HelpBalloon from 'components/Intelligence/component/HelpBalloon/HelpBalloon';
import './SettingsContent.scss';

const humansType = ['Zendesk', 'Omni', 'Ayty', 'Genesys Cloud'];
const INITIAL_VALUE_ZENDESK_INFO = { accountKey: '' };
const PURE_CLOUD_REGIONS_HOSTS = [
  'us_east_1',
  'eu_west_1',
  'ap_southeast_2',
  'ap_northeast_1',
  'eu_central_1',
  'us_west_2',
  'ca_central_1',
  'ap_northeast_2',
  'eu_west_2',
  'ap_south_1',
  'us_east_2',
];

const QUEUE_TIME_OPTIONS = {
  NO_MESSAGE: 'Não avisar',
  ONE_TIME: 'Avisar apenas uma vez',
  ONE_IN_A_MINUTE: 'Avisar de 1 em 1 minuto',
};

const INITIAL_VALUE_GENESYS_INFO = {
  clientId: '',
  clientSecret: '',
  genesysCloud: '',
  queueTimeOption: 'NO_MESSAGE',
  queueTimeMessage:
    'O tempo de espera para o seu atendimento é de {genesys.estimatedQueue} segundos.',
};

const SettingsContentHuman = (props) => {
  const { bot, updateBotHumanAttendanceRequest, user } = props;
  const { i18n } = useTranslation();

  const setCurrentHumanSelectedInitialValue = () => {
    if (bot) {
      if (bot.settings && bot.settings.human) {
        const { selected } = bot.settings.human;
        return selected || 'Omni';
      }
      return '';
    }
    return '';
  };

  const setZendeskInfoInitialValue = () => {
    if (bot) {
      if (bot.settings && bot.settings.human && bot.settings.human.zendesk) {
        const { zendesk } = bot.settings.human;
        return zendesk;
      }
      return INITIAL_VALUE_ZENDESK_INFO;
    }
    return INITIAL_VALUE_ZENDESK_INFO;
  };

  const setGenesysInfoInitialValue = () => {
    if (bot) {
      if (bot.settings && bot.settings.human && bot.settings.human.genesys) {
        const { genesys } = bot.settings.human;
        genesys.queueTimeOption = genesys.queueTimeOption || 'NO_MESSAGE';
        genesys.queueTimeMessage =
          genesys.queueTimeMessage ||
          'O tempo de espera para o seu atendimento é de {genesys.estimatedQueue} segundos';
        return genesys;
      }
      return INITIAL_VALUE_GENESYS_INFO;
    }
    return INITIAL_VALUE_GENESYS_INFO;
  };

  const [endPoints, setEndpoints] = useState(
    bot.settings && bot.settings.human ? bot.settings.human.endPoints || {} : {}
  );
  const [zendeskInfo, setZendeskInfo] = useState(
    setZendeskInfoInitialValue(bot)
  );
  const [genesysInfo, setGenesysInfo] = useState(
    setGenesysInfoInitialValue(bot)
  );
  const [currentHumanSelected, setCurrentHumanSelected] = useState(
    setCurrentHumanSelectedInitialValue(bot)
  );
  const [showDropdown, setShowDropdown] = useState(true);
  const [showGenesysDropdown, setShowGenesysDropdown] = useState(true);
  const [
    showGenesysQueueTimeDropdown,
    setShowGenesysQueueTimeDropdown,
  ] = useState(true);
  const humanWrapperRef = useRef(null);
  const genesysWrapperRef = useRef(null);
  const genesysQueueTimeWrapperRef = useRef(null);

  /**
   * Add mouse click listener for close de dropdown menu
   */
  useEffect(() => {
    document.addEventListener('click', onClickOutsideComponent, false);
    document.addEventListener('click', onClickOutsideComponent, false);
    return () => {
      document.removeEventListener('click', onClickOutsideComponent, false);
    };
  }, []);

  const changeEndPoints = (name, value) => {
    setEndpoints((OldEndPoints) => {
      const newEndPoints = {
        ...OldEndPoints,
      };
      newEndPoints[name] = value;
      return newEndPoints;
    });
  };

  const updateBot = () => {
    if (bot) {
      const data = { selected: currentHumanSelected, endPoints };
      if (currentHumanSelected === 'Zendesk') {
        data.zendesk = zendeskInfo;
      }
      if (currentHumanSelected === 'Genesys Cloud') {
        data.genesys = genesysInfo;
      }
      updateBotHumanAttendanceRequest(bot._id, data);
    }
  };

  /**
   * Called for change the dropdown hidden
   */
  const onHumanTypeSelectedClick = () => {
    setShowDropdown(!showDropdown);
  };

  /**
   * Called when user selected new attendance human type
   *
   * @param {string} newOption new attendance human type selected
   */
  const onHumanTypeOptionSelected = (newOption) => {
    setCurrentHumanSelected(newOption);
    onHumanTypeSelectedClick();
  };

  /**
   * Called when user click outside from the extract dropdown
   *
   * @param {Object} event event from mouse
   */
  const onClickOutsideComponent = (event) => {
    if (
      humanWrapperRef.current &&
      !humanWrapperRef.current.contains(event.target)
    ) {
      setShowDropdown(true);
    }

    if (
      genesysWrapperRef.current &&
      !genesysWrapperRef.current.contains(event.target)
    ) {
      setShowGenesysDropdown(true);
    }

    if (
      genesysQueueTimeWrapperRef.current &&
      !genesysQueueTimeWrapperRef.current.contains(event.target)
    ) {
      setShowGenesysQueueTimeDropdown(true);
    }
  };

  /**
   * Called when Zendesk Chat account_key field change his value
   *
   * @param {string} accountKey new value for the accountKey field
   */
  const onZendeskChatAccountKeyChange = (accountKey) => {
    const newZendeskInfo = { ...zendeskInfo, accountKey };
    setZendeskInfo(newZendeskInfo);
  };

  /**
   * Called when Genesys Info field change his value
   *
   * @param {string} key value key that changed
   * @param {string} value new key value
   */
  const onGenesysInfoChange = (key, value) => {
    const newGenesysInfo = { ...genesysInfo };
    newGenesysInfo[key] = value;
    setGenesysInfo(newGenesysInfo);
  };

  /**
   * Get current attendance human is selected for the input label
   *
   * @returns {string}
   */
  const getHumanTypeSelectedLabel = () => {
    return currentHumanSelected && currentHumanSelected !== ''
      ? currentHumanSelected
      : i18n.t('Selecione um tipo');
  };

  /**
   * Get current attendance human is selected for the input label
   *
   * @returns {string}
   */
  const getGenesysRegionSelectedLabel = () => {
    return genesysInfo &&
      genesysInfo.genesysCloud &&
      genesysInfo.genesysCloud !== ''
      ? genesysInfo.genesysCloud
      : i18n.t('Selecione uma região');
  };

  /**
   * Render the pure cloud regions options
   */
  const renderGenesysRegionsOptions = () => {
    const options = PURE_CLOUD_REGIONS_HOSTS.map((option) => {
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
          key={option}
          className="select-line"
          onClick={() => {
            onGenesysInfoChange('genesysCloud', option);
            setShowGenesysDropdown(!showGenesysDropdown);
          }}
        >
          <span>{i18n.t(option)}</span>
        </div>
      );
    });

    return options;
  };

  const renderGenesysQueueTimeOptions = () => {
    const options = [];
    _.forIn(QUEUE_TIME_OPTIONS, (value, key) => {
      options.push(
        <div
          key={value}
          className="select-line"
          onClick={() => {
            onGenesysInfoChange('queueTimeOption', key);
            setShowGenesysQueueTimeDropdown(!showGenesysQueueTimeDropdown);
          }}
        >
          <span>{i18n.t(value)}</span>
        </div>
      );
    });

    return options;
  };

  /**
   * Render the humans types options
   */
  const renderHumanOptions = () => {
    const options = humansType.map((option) => {
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
          key={option}
          className="select-line"
          onClick={() => onHumanTypeOptionSelected(option)}
          style={{
            backgroundColor:
              bot.settings.human && bot.settings.human.selected === option
                ? '#ff9d8a'
                : '',
            fontWeight:
              bot.settings.human && bot.settings.human.selected === option
                ? 'bold'
                : '',
          }}
        >
          <span>{i18n.t(option)}</span>
        </div>
      );
    });

    return options;
  };

  /**
   * Render human select html element
   */
  const renderHumanSelect = () => {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className="human-type-select" ref={humanWrapperRef}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className="human-type-options"
          onClick={
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? () => onHumanTypeSelectedClick()
              : ''
          }
        >
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            id="human-type-options-input"
            type="text"
            value={currentHumanSelected}
          />
          <span>{getHumanTypeSelectedLabel()}</span>
          <i className="arrow down" />
        </div>
        <div
          id="dropdown"
          className="human-type-dropdown"
          hidden={showDropdown}
        >
          {renderHumanOptions()}
        </div>
      </div>
    );
  };

  /**
   * Render human select html element
   */
  const renderGenesysRegionsSelect = () => {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className="human-type-select" ref={genesysWrapperRef}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className="human-type-options"
          onClick={
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? () => setShowGenesysDropdown(!showGenesysDropdown)
              : ''
          }
        >
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            id="human-type-options-input"
            type="text"
            value={currentHumanSelected}
          />
          <span>{getGenesysRegionSelectedLabel()}</span>
          <i className="arrow down" />
        </div>
        <div
          id="dropdown"
          className="human-type-dropdown genesys-dropdown"
          hidden={showGenesysDropdown}
        >
          {renderGenesysRegionsOptions()}
        </div>
      </div>
    );
  };

  const renderQueueTimeOptionsSelect = () => {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className="human-type-select" ref={genesysQueueTimeWrapperRef}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className="human-type-options"
          onClick={
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? () =>
                  setShowGenesysQueueTimeDropdown(!showGenesysQueueTimeDropdown)
              : ''
          }
        >
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            id="human-type-options-input"
            type="text"
            value={currentHumanSelected}
          />
          <span>
            {QUEUE_TIME_OPTIONS[genesysInfo.queueTimeOption] ||
              QUEUE_TIME_OPTIONS.NO_MESSAGE}
          </span>
          <i className="arrow down" />
        </div>
        <div
          id="dropdown"
          className="human-type-dropdown genesys-dropdown"
          hidden={showGenesysQueueTimeDropdown}
        >
          {renderGenesysQueueTimeOptions()}
        </div>
      </div>
    );
  };

  /**
   * Get Zendesk Chat account_key input element
   */
  const renderZendeskOptions = () => {
    if (currentHumanSelected !== 'Zendesk') {
      return false;
    }

    return (
      <div className="form-group mt-2">
        <label>{i18n.t('Zendesk Chat Account Key')}:</label>
        <input
          disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
          name="zendesk-account-key"
          className="form-control human-input-width"
          placeholder="Ex.: JYds3wGcyqFu1pAAA0=="
          value={zendeskInfo.accountKey}
          onChange={(e) => onZendeskChatAccountKeyChange(e.target.value)}
        />
      </div>
    );
  };

  /**
   * Get Genesys informations input elements
   */
  const renderGenesysOptions = () => {
    if (currentHumanSelected !== 'Genesys Cloud') {
      return false;
    }

    return (
      <>
        <div className="form-group mt-3">
          <label>{i18n.t('Selecione a região do PureCloud')}:</label>
          {renderGenesysRegionsSelect()}
        </div>

        <div className="form-group mt-2">
          <label>{i18n.t('ClientId')}:</label>
          <HelpBalloon
            id="clientId"
            message="O cliente precisa ter as permissões admin e Master Admin"
          />
          <input
            disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
            name="genesys-client-id"
            className="form-control human-input-width"
            placeholder="Ex.: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
            value={genesysInfo.clientId}
            onChange={(e) => onGenesysInfoChange('clientId', e.target.value)}
          />
        </div>

        <div className="form-group mt-2">
          <label>{i18n.t('ClientSecret')}:</label>
          <input
            disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
            name="genesys-client-secret"
            className="form-control human-input-width"
            placeholder="Ex.: BLus9AXzWwg4C97XKe1AtfkCDi_wnq5p-fWuZVIAnTU"
            value={genesysInfo.clientSecret}
            onChange={(e) =>
              onGenesysInfoChange('clientSecret', e.target.value)
            }
          />
        </div>

        <div className="form-group mt-3">
          <label>{i18n.t('Avisar o tempo estimado de espera')}:</label>
          {renderQueueTimeOptionsSelect()}
        </div>

        {genesysInfo.queueTimeOption === 'NO_MESSAGE' ? null : (
          <div className="form-group mt-2">
            <label>{i18n.t('Mensagem para o tempo estimado de espera')}:</label>
            <textarea
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              name="genesys-client-secret"
              className="form-control human-input-width"
              placeholder="O tempo de espera para o seu atendimento é de {genesys.estimatedQueue} segundos."
              onChange={(e) =>
                onGenesysInfoChange('queueTimeMessage', e.target.value)
              }
            >
              {genesysInfo.queueTimeMessage}
            </textarea>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="human-type-container layout-human-container">
      <div className="layout-title-human-container">
        <div className="title">
          {i18n.t('Configuração de Criador ')}
          <strong>{i18n.t('Atendimento Humano')}</strong>
        </div>
        <div className="subtitle mt-2">
          {i18n.t(
            'Configure o comportamento do bloco "Humano" no background do seu bot'
          )}
        </div>
      </div>
      <div
        className="human-type-container layout-inputs-human-container"
        style={{ height: '70%' }}
      >
        <div className="form-group mt-3">
          <label>{i18n.t('Selecione a plataforma de atendimento')}:</label>
          {renderHumanSelect()}
        </div>
        <div className="form-group mt-3">
          <label>{i18n.t('Endpoint para Início de Conversa')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="start"
            className="form-control human-input-width"
            placeholder="https://URL/start"
            value={endPoints.start || ''}
            onChange={(e) => changeEndPoints(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-2">
          <label>{i18n.t('Endpoint para Recebimento de Mensagens')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="message"
            className="form-control human-input-width"
            placeholder="https://URL/message"
            value={endPoints.message || ''}
            onChange={(e) => changeEndPoints(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-2">
          <label>{i18n.t('Endpoint para Recebimento de Status')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="status"
            className="form-control human-input-width"
            placeholder="https://URL/status"
            value={endPoints.status || ''}
            onChange={(e) => changeEndPoints(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-2">
          <label>{i18n.t('Endpoint para Filas de Atendimento')}:</label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="queue"
            className="form-control human-input-width"
            placeholder="https://URL/queue/list/:id"
            value={endPoints.queue || ''}
            onChange={(e) => changeEndPoints(e.target.name, e.target.value)}
          />
        </div>
        <div className="form-group mt-2">
          <label>
            {i18n.t('Endpoint para Validação de agente disponivel')}:
          </label>
          <input
            disabled={!!(user?.selectedCompany?.claim?.name === 'Viewer')}
            name="agent"
            className="form-control human-input-width"
            placeholder="https://URL/agent/check/:id"
            value={endPoints.agent || ''}
            onChange={(e) => changeEndPoints(e.target.name, e.target.value)}
          />
        </div>
        {renderZendeskOptions()}
        {renderGenesysOptions()}
        <div className="form-group mt-3">
          <button
            type="button"
            disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
            className="btn btn-primary"
            onClick={updateBot}
          >
            {i18n.t('salvar')}
          </button>
        </div>
      </div>
      {currentHumanSelected === 'Genesys Cloud' ? (
        <div className="genesys-human-container">
          <div className="genesys-info">
            <h3>Dados do cliente</h3>
            <p>
              Para enviar informações do contato para o Genesys Cloud, utilize
              as variáveis padrão conforme modelo:
            </p>
            <p className="genesys-info-examples">
              genesys.displayName = Nome do contato
              <br />
              genesys.email = E-mail do contato
              <br />
              genesys.phoneNumber = Número do contato
              <br />
              genesys.addressStreet = Endereço do contato
              <br />
              genesys.addressCity = Endereço do contato
              <br />
              genesys.addressState = Endereço do contato
              <br />
              genesys.addressPostalCode = Endereço do contato
              <br />
            </p>
            <p>
              Para informações customizadas, adicionar ao prefixo genesys
              conforme modelo:
              <br />
            </p>
            <p className="genesys-info-examples">
              genesys.apelido = dado customizado
              <br />
              genesys.nomeEmpresa = dado customizado
              <br />
              genesys.documento = dado customizado
              <br />
            </p>
            <p className="genesys-info-warn">
              * limite de 3 campos customizados
              <br />* para mais informações consulte nossa página de ajuda
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SettingsContentHuman;
